// Import 3rd party
import 'foundation-sites/dist/js/plugins/foundation.core.js';
import 'foundation-sites/dist/js/plugins/foundation.tabs.js';
import 'featherlight/src/featherlight.js';
import 'featherlight/src/featherlight.gallery.js';

// Import partials
import { throttle } from './utils.js';

import './partials/accordion.js';
import './partials/ajax-pagination.js';
import './partials/ajax.js';
import './partials/forms.js';
import './partials/issues-filter.js';
import './partials/navigation.js';
import './partials/skip-link-focus-fix.js';
import './partials/sticky-contact-card.js';
import './partials/tabs.js';
import './partials/toggles.js';
import './partials/tooltips.js';
import './partials/project-v2.js';
import './bbc-wb-access-resources.js';
import './blob-image-video.js';
import './sliders-v2.js';
import './lightbox-v2.js';
import './project-download-modal.js';
import './project-testimonials.js';
import './contact-card.js';
import './masonry-gallery.js';
import './video.js';

// Register static assets
import.meta.glob(['../images/**', '../fonts/**'], {});

(function ($) {
  $(document).foundation();

  // Smooth scrolling
  $('a[href*="#"]:not([href="#"]):not(.js-tab-link):not(.js-no-smooth)').on(
    'click',
    function () {
      if (
        location.pathname.replace(/^\//, '') ==
          this.pathname.replace(/^\//, '') ||
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          $('html,body').animate(
            {
              scrollTop: target.offset().top - 80, // 80 is height of header
            },
            500,
          );
          return false;
        }
      }
    },
  );

  /* Responsive menu behaviour */
  var MobileMenu = (function () {
    var handleHeader = function () {
      var $toggleBtn = $('.js-toggle-nav'),
        $navWrapper = $('.js-header-nav'),
        $main = $('#top');

      $toggleBtn.on('click', function (/*event*/) {
        $(this).toggleClass('is-toggled');
        $navWrapper.toggleClass('is-toggled');
        $main.toggleClass('is-toggled');

        // Close search bar when nav is opened
        if ($('.js-search-bar').hasClass('is-toggled')) {
          $('.js-close-search').trigger('click');
        }
        //event.preventDefault();
      });
    };

    function init() {
      handleHeader();
    }

    return {
      init: init,
    };
  })();

  $(document).ready(MobileMenu.init);

  function checkTopNavIsScrollable() {
    var $nav = $('.js-top-navigation');
    if ($nav.length == 0) {
      return;
    }

    var isScrollable = $nav[0].scrollWidth > $nav[0].clientWidth;

    if (isScrollable) {
      $nav.closest('.header-top--mobile').addClass('is-scrollable');
    } else {
      $nav.closest('.header-top--mobile').removeClass('is-scrollable');
    }
  }

  // Check if mobile top nav is scrollable when menu is opened and apply class to show arrows
  $(document).on('click', '.js-toggle-nav', checkTopNavIsScrollable);

  /* change header class when scrolled */
  var setHeaderType = function () {
    var $scroll = $(window).scrollTop();
    var $header = $('.js-header');

    if ($scroll > 50) {
      $header.addClass('is-scrolled');
    } else if ($scroll < 50) {
      $header.removeClass('is-scrolled');
    }
  };
  setHeaderType();

  /* apply throttle on scroll event, so function isn't initiated all the time */
  $(window).on('scroll', throttle(setHeaderType, 10));

  $(window).on('resize', function () {
    setHeaderType();
  });

  // init gallery lightbox
  if (typeof $.featherlightGallery == 'function') {
    $('.js-featherlight-gallery').featherlightGallery();
  }

  /**
   * Checks href targets to see if a given anchor is linking to an image.
   */
  function testImagesExt(index, element) {
    return /(.png|.jpg|.jpeg|.gif|.tiff|.bmp)$/.test(
      $(element).attr('href').toLowerCase().split('?')[0].split('#')[0],
    );
  }
  // Enable lightbox for content images
  $('.entry-content')
    .find('a[href]')
    .filter(testImagesExt)
    .attr('data-featherlight', 'image');

  // Button Tabs link
  // get text from active tab and set this text on tabs button
  $('.js-stories-tabs .js-tab-text').text(
    $(document).find('.js-stories-tabs-item.is-active').text(),
  );

  // Update text when tab is changed
  $('.js-stories-tabs-item').on('click', function () {
    $('.js-stories-tabs .js-tab-text').text(
      $(this).find('.js-tab-link').text(),
    );
  });

  // When button is clicked display tabs nav
  $('.js-stories-tabs-btn').on('click', function () {
    var $button = $(this);

    if (!$button.hasClass('is-expanded')) {
      $button.addClass('is-expanded');
      $('.js-stories-tabs').addClass('is-expanded');
    } else {
      $button.removeClass('is-expanded');
      $('.js-stories-tabs').removeClass('is-expanded');
    }
  });
})(jQuery);
